<template>
  <div>
    <el-dialog title="自动提交外部售后配置" :visible.sync="automaticallySubmitVisible" :close-on-click-modal="false" width="900px"
      @closed="automaticallySubmitVisible = false">
      <div class="button_top">
        <div class="radiobtn">
          <div class="faultBtn">
            <div v-bind:class="automaticallyClickShow === '01' ? 'active' : 'none'"
              @click="automaticallyClickShow = '01'">
              启用自动提交说明
            </div>
            <div v-bind:class="automaticallyClickShow === '02' ? 'active' : 'none'"
              @click="automaticallyClickShow = '02'">
              启用/关闭自动提交
            </div>
          </div>
        </div>
      </div>
      <el-table :data="describeData" style="width: 100%;margin: 50px 0;" v-if="automaticallyClickShow == '01'">
        <el-table-column type="index" width="50" label="序号" align='center'>
        </el-table-column>
        <el-table-column prop="type" label="类型" width="160" align='center'>
          <template slot-scope="scope">
            <span style="font-weight: 800;">{{ scope.row.type }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="shuoming" label="取值说明" header-align='center'>
          <template slot-scope="scope" style="margin: 5px;">
            <div style="color: #0981FF;" v-for="(item, index) of scope.row.shuoming" :key="index">
              {{ item }}
            </div>
          </template>
        </el-table-column>
      </el-table>

      <el-table :data="automaticallyTableData" style="width: 100%;margin: 50px 0;"
        v-if="automaticallyClickShow == '02'">
        <el-table-column type="index" width="50" label="序号" align='center'>
        </el-table-column>
        <el-table-column v-for="(item, index) of automaticallyColumn" :key="index" :prop="item.prop" :label="item.label"
          align='center'>
        </el-table-column>
        <el-table-column label="渠道唯一路由" align='center'>
          <template slot-scope="scope">
            {{ scope.row.code || '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="isSubmit" label="初审通过自动向外部提交追差" align='center'>
          <template slot-scope="scope">
            <!-- :disabled="!scope.row.isApr" -->
            <el-switch v-model="scope.row.isSubmit" @change="autoAprChange(scope.row)">
            </el-switch>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog :title="codeTitle" :visible.sync="autocodeShow" :close-on-click-modal="false" width="500px"
      @closed="autocodeShow = false, autocode = '', getAutoApplyChannelList()">
      <div style="font-weight: 600; display: flex;justify-content: center;align-items: center; margin: 15px 0;">
        <span>是否确认</span>
        <span>{{ automaticallyRow.isSubmit ? '开启' : '关闭' }}</span>
        <span style="color: #0981FF;">{{ automaticallyRow.companyName }}</span>
        <span>自动提交追差功能？</span>
      </div>
      <div style="display: flex; align-items: center; margin-bottom: 10px;">
        <div style="width: 88px">动态口令：</div>
        <el-input v-model="autocode" placeholder="请输入谷歌动态口令"
          oninput="this.value = this.value.replace(/[^0-9a-zA-Z]/ig,'')"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="autocodeShow = false, autocode = ''">取消</el-button>
        <el-button type="primary" :loading="excelLoading" @click.native="autocodeSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import _api from "@/utils/request";
import { http } from "@/utils/request/caiHuoXiaReview"

export default {
  data() {
    return {
      automaticallySubmitVisible: false,
      automaticallyClickShow: '01',
      describeData: [
        {
          type: "满足自动申请条件",
          shuoming: [
            "1.商户已启用自动提交追差；",
            "2.平台初审通过时，选择门店商责任或共同责任；",
            "3.该订单未向外部发起过追差",
          ],
        },
        // {
        //   type: "申请时机",
        //   shuoming: [
        //     "若售后配置-申请时机为回收商提交售后时申请显示：回收商申请追差时自动提交",
        //     "若售后配置-申请时机为平台初审通过时申请显示：平台初审通过时提交",
        //   ],
        // },
        {
          type: "申请金额",
          shuoming: [
            "初审通过门店商承担金额≤外部成交金额：取门店商承担金额",
            "初审通过门店商承担金额＞外部成交金额：取外部成交金额",
          ],
        },
        {
          type: "追差类型",
          shuoming: [
            "采货侠渠道：取关联繁星平台的追差分类的外部追差类型，若未关联则不执行自动提交",
            "非采货侠渠道：无需传该字段",

          ],
        },
        {
          type: "追差备注",
          shuoming: [
            "采货侠渠道：取初审通过平台审差填写的判责理由，超出部分自动截取",
            "其他渠道：取回收商选择追差类型+初审通过判责原因内容，超出部分自动截取",
          ],
        },
        {
          type: "追差凭证",
          shuoming: [
            "取回收商发起追差上传的照片、视频",
          ],
        },
      ],
      automaticallyColumn: [
        {
          prop: 'channelName',
          label: '渠道商名称'
        },
        {
          prop: 'companyName',
          label: '门店商户'
        },
        // {
        //   prop: 'code',
        //   label: '渠道商编号'
        // }
      ],
      automaticallyTableData: [],
      codeTitle: '',
      automaticallyRow: {},
      autocodeShow: false,
      autocode: '',
      excelLoading: false,
      channelCode: ''
    };
  },
  methods: {
    open(channelCode) {
      console.log('111');
      this.channelCode = channelCode
      this.automaticallySubmitVisible = true
      console.log('automaticallySubmitVisible', this.automaticallySubmitVisible);

      this.getAutoApplyChannelList()
    },
    getAutoApplyChannelList() {
      if (this.channelCode == 'fengongsi') {
        http.innerAutomaticConfigs().then((res) => {
          this.automaticallyTableData = res.data
        }).finally(() => {

        })
      } else {
        http.autoApplyChannelList({ channelCode: this.channelCode }).then((res) => {
          this.automaticallyTableData = res.data
        }).finally(() => {

        })
      }

    },
    automaticallyChange(val) {
      this.automaticallyClickShow = val
    },
    autoAprChange(row) {
      console.log(row, 111);
      const { isSubmit } = row
      this.automaticallyRow = row
      this.autocodeShow = true
      this.codeTitle = isSubmit ? '启用提示' : '禁用提示'
    },
    autocodeSubmit() {
      if (!this.autocode) {
        return this.$message.error("请输入谷歌动态码");
      }
      this.excelLoading = true;
      const { id, isSubmit } = this.automaticallyRow
      http.automaticSubmission({ id, isSubmit, command: this.autocode }).then((r) => {

        this.excelLoading = false;
        this.autocodeShow = false
        return this.$message.success(r.msg);

      }).finally((le) => {
        this.excelLoading = false;

      })
    },

    close() {
      this.automaticallySubmitVisible = false
    },
    confirm() {
      this.close()
      this.$emit('confirm')
    }
  }
};
</script>

<style lang="scss" scoped>
.button_top {
  cursor: pointer;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.faultBtn {
  width: 300px;
  height: 42px;
  background: #f9fbfd;
  border: 1px solid #c1d1ff;
  box-shadow: 0px 4px 8px 0px rgba(196, 197, 198, 0.2);
  border-radius: 21px;
  display: flex;

  .active {
    text-align: center;
    color: white;
    width: 50%;
    height: 40px;
    font-size: 14px;
    font-family: FZLanTingHei-M-GBK;
    font-weight: 400;
    line-height: 40px;
    background: #0981ff;
    border-radius: 20px;
  }

  .none {
    text-align: center;
    color: #333;
    width: 50%;
    height: 40px;
    font-size: 14px;
    font-family: FZLanTingHei-M-GBK;
    font-weight: 400;
    line-height: 40px;
    border-radius: 20px;
  }
}
</style>